import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { TasksService } from 'src/app/services/tasks.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-tool-create',
  template: `
    <div class="row">
      <div class="col-sm-12 offset-sm-0 col-lg-9 offset-lg-3 mt-5">
      <xng-breadcrumb ></xng-breadcrumb>
        <div class="row mb-4 mt-4">
          <div class="col-md-9">
            <h1>Herramienta</h1>
            <p>Configura las herramientas que están disponibles para los técnicos.</p>
          </div>
          <div class="col-md-3 text-end mt-4">
            
          </div>
        </div>
        <div class="row">
          <div class="col-md-7">
            <div class="card border-0 rounded-4 shadow">
              <div class="card-body p-4">
                <div class="row">
                  <div class="col-md-12">
                    <h4>Agregar herramienta</h4>
                    <p>Configura la herramienta con los siguientes campos.</p>
                    <app-form-tool (toolData)="createTool($event)" [profile]="profile" [loading]="loading"></app-form-tool>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ToolCreateComponent implements OnInit {
  loading: boolean = false;
  storageService = inject(StorageService);
  profile: any = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.PROFILE) ?? '{}');

  constructor(
    private store: SettlementsService,
    private tasks: TasksService,
    private toastr: ToastrService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
  ) { }

  ngOnInit(): void {
    this.breadcrumbService.set('@toolCreate', 'Crear herramienta');
  }

  createTool(event: any) {
    this.tasks.createTool(event).subscribe({
      next: (data: any) => {
        console.log(data);
        this.toastr.success('Herramienta creada correctamente.');
        this.router.navigate(['/inventory/tools']);
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error('Ocurrió un error al crear la herramienta.');
      }
    });
  }
}
